export default __webpack_public_path__ + "static/media/default.21b12e71.png";